import { doc, DocumentData, getDoc, setDoc } from "firebase/firestore";
import { db } from "./firebase";
import { Globals } from "../globals";
import { gemeindeSubPath } from "./gemeindePaths";

/**
 * gemeinden/{gemeindeId}/config/notificationSettings holds several independent
 * groups of settings (notification channels, choir reminder, Synology sync) that
 * are edited on different pages. Every page reads and writes through these two
 * helpers so that a save only ever merges its own fields and never replaces the
 * document – otherwise one page would wipe the other page's settings.
 */
function settingsDoc(gemeindeId: string) {
    return doc(
        db,
        ...gemeindeSubPath(gemeindeId, Globals.GEMEINDE_CONFIG_SUBCOLLECTION, Globals.NOTIFICATION_SETTINGS_DOC_ID)
    );
}

/** Loads the raw settings document of a Gemeinde ({} if it does not exist yet). */
export async function loadGemeindeSettings(gemeindeId: string): Promise<DocumentData> {
    const snap = await getDoc(settingsDoc(gemeindeId));
    return snap.exists() ? snap.data() : {};
}

/** Merges the given fields into the settings document of a Gemeinde. */
export async function saveGemeindeSettings(gemeindeId: string, fields: DocumentData): Promise<void> {
    await setDoc(settingsDoc(gemeindeId), fields, { merge: true });
}

/**
 * Replaces the given top-level fields as a whole and leaves every other field
 * alone. Needed for map fields: a merge would combine the stored map with the
 * new one, so an entry removed on the page would come back (GOD-48).
 */
export async function replaceGemeindeSettingsFields(gemeindeId: string, fields: DocumentData): Promise<void> {
    await setDoc(settingsDoc(gemeindeId), fields, { mergeFields: Object.keys(fields) });
}
